import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from "@angular/core";
import { Opleiding } from "../../../model/opleiding/opleiding";
import { ContentService } from "../../../services/content/content.service";
import { OpleidingCardEnum } from "./opleiding-card.enum";

const content = require("./opleiding-card.content.json");

@Component({
  selector: "app-opleiding-card",
  templateUrl: "./opleiding-card.component.html",
  styleUrls: ["./opleiding-card.component.scss"],
})
export class OpleidingCardComponent implements OnChanges, OnInit {
  @ViewChild("label", { static: true, read: ElementRef })
  public label: ElementRef;

  @Input()
  public opleiding: Opleiding;

  @Input()
  public mode: OpleidingCardEnum = OpleidingCardEnum.DEFAULT;

  @Input()
  public showMatchPercentage: boolean = false;

  @Output()
  public preview: EventEmitter<any> = new EventEmitter();

  @Output()
  // eslint-disable-next-line @angular-eslint/no-output-native
  public select: EventEmitter<any> = new EventEmitter();

  @Output()
  public favorite: EventEmitter<Opleiding> = new EventEmitter();

  public color: string;
  public opleidingsniveaus: string;

  public constructor(
    private renderer: Renderer2,
    private contentService: ContentService
  ) {
    this.contentService.loadContent(content);
  }

  public ngOnChanges(changes: any): void {
    this.opleidingsniveaus =
      changes.opleiding.currentValue.opleidingsniveaus.join(", ");
  }

  public ngOnInit(): void {
    switch (this.opleiding.soort) {
      case "Beroepsonderwijs": {
        this.renderer.setStyle(
          this.label.nativeElement,
          "background-color",
          "#8c90ae"
        );
        break;
      }
      case "Bijscholing": {
        this.renderer.setStyle(
          this.label.nativeElement,
          "background-color",
          "#103c51"
        );
        break;
      }
      case "Beroepsspecialisatie": {
        this.renderer.setStyle(
          this.label.nativeElement,
          "background-color",
          "#e94f00"
        );
        break;
      }
      case "Voorschakeltraject": {
        this.renderer.setStyle(
          this.label.nativeElement,
          "background-color",
          "#87a87e"
        );
        break;
      }
      case "Mbo-certificaat": {
        this.renderer.setStyle(
          this.label.nativeElement,
          "background-color",
          "#80c0d5"
        );
        break;
      }
      default: {
        this.renderer.setStyle(
          this.label.nativeElement,
          "background-color",
          "#8c90ae"
        );
      }
    }
  }

  public handlePreviewClick(): void {
    this.preview.emit(this.opleiding);
  }

  public handleSelect(): void {
    this.select.emit(this.opleiding);
  }

  public shorten(string, amount): string {
    if (string.length > amount) {
      return string.substr(0, amount) + "...";
    }
    return string;
  }

  handleFavoriteClick(): void {
    this.favorite.emit(this.opleiding);
  }
}
